export default "/images/4294a185b4584733cbf1f43552408dc4.avif";